import { useState } from 'react';

export type DataDetail<Res, Params extends unknown[] = unknown[]> = (
	...args: Params
) => Promise<Res>;

type UseDetail<Res, Params extends unknown[] = unknown[]> = {
	loading: boolean;
	fetchDetail: DataDetail<Res, Params>;
  detail: Res | undefined;
};

const useDataDetail = <Res extends { id: string }, Params extends unknown[] = unknown[]>({
	api,
  initValue
}: {
	api: DataDetail<Res, Params>;
  initValue?: Res;
}): UseDetail<Res, Params> => {
	const [loading, setLoading] = useState<boolean>(false);
  const [detail, setDetail] = useState<Res | undefined>(initValue || undefined);

	const fetchDetail: DataDetail<Res, Params> = (...args: Params) => {
		setLoading(true);
		return new Promise<Res>((resolve, reject) => {
			api(...args)
				.then((res) => {
          setDetail(res)
          resolve(res)
        })
				.catch((error) => reject(error))
				.finally(() => setLoading(false));
		});
	};

	return { loading, fetchDetail, detail };
};

export default useDataDetail;
